import type { ReactNode } from 'react';

interface Props {
  icon: string;
  title: string;
  description?: ReactNode;
  children: ReactNode;
}

export const StepPanel = ({ icon, title, description, children }: Props) => (
  <div className="mx-auto flex max-w-[960px] flex-col overflow-hidden rounded-lg bg-white shadow-card md:flex-row">
    <aside className="flex w-full flex-col items-center bg-navy p-6 text-center text-white md:w-[240px] md:shrink-0 md:p-9">
      <div className="mb-4 flex h-20 w-20 items-center justify-center rounded-full border-[3px] border-teal">
        <i className={`fas ${icon} text-[30px] text-teal`} />
      </div>
      <div className="mb-3.5 text-[20px] font-black uppercase leading-tight">{title}</div>
      {description && (
        <div className="text-xs leading-relaxed text-white/70">{description}</div>
      )}
    </aside>
    <section className="flex-1 bg-white p-6 md:p-9">{children}</section>
  </div>
);
